<div class="flex justify-between header">
  <h2>{{data.shareholder ? 'Modifica socio' : 'Aggiungi socio'}}</h2>
  <button mat-icon-button mat-dialog-close aria-label="Chiudi" matTooltip="Chiudi">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="primary-bg header min-height">
  <h2>{{data.personaGiuridica?.denominazione}}</h2>
  <p class="small light">{{data.personaGiuridica?.partitaIva}}</p>
</div>

<mat-dialog-content class="double-header-dialog-content">



  <smart-form [fields]="fields"></smart-form>




</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-flat-button class="big" color="accent" (click)="save()">{{data.shareholder?.id ?
    'Modifica' :
    'Salva'}}</button>
</mat-dialog-actions>